import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataInput } from '@trivelope/triv-ui-tools-lib';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.css']
})
export class PasswordInputComponent implements OnInit {
  @Input() fGroup!: FormGroup;
  @Input() data!: DataInput;

  showPassword = false;
  hasValue = false;

  ngOnInit() {
    const passwordControl = this.fGroup.get(this.data.id);
    if (passwordControl) {
      passwordControl.valueChanges.subscribe(value => {
        this.hasValue = !!value;
      });
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.data.type = this.showPassword ? 'text' : 'password';
  }
}
